  <kendo-formfield *ngIf="form.controls.responsible.value.length > 1" [formGroup]="form">
    <kendo-label [for]="firstResponseApplies" [text]="'step.form.firstResponsibleApplies.label' | i18n"></kendo-label>
    <kendo-switch
      #firstResponseApplies
      [formControlName]="'firstResponseApplies'"
      [onLabel]="'step.form.firstResponsibleApplies.onLabel' | i18n"
      [offLabel]="'step.form.firstResponsibleApplies.offLabel' | i18n"
      ></kendo-switch>
      <kendo-formhint>
        <div *ngIf="form.controls.firstResponseApplies.value" >
          {{ 'step.form.firstResponsibleApplies.hint.yes' | i18n }}
        </div>
        <div *ngIf="!form.controls.firstResponseApplies.value" >
          {{ 'step.form.firstResponsibleApplies.hint.no' | i18n }}
        </div>
      </kendo-formhint>
  </kendo-formfield>
